import React, { useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import './SubmenuInformatique.css';
import { HashLink } from 'react-router-hash-link';

const SubMenuInformatique = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [submenuOpen, setSubmenuOpen] = useState(false);

    const isHashActive = (hash) => location.hash === hash;

    return (
        <div 
            className="navlink_with_submenu"
            onMouseEnter={() => setSubmenuOpen(true)}
            onMouseLeave={() => setSubmenuOpen(false)}
        >
            <NavLink
                to="/informatique"
                className={({ isActive }) => (isActive ? "active" : "")}
                aria-haspopup="true"
                aria-expanded={submenuOpen}
            >
                Informatique
            </NavLink>

            <div className={`submenu submenuinfo ${submenuOpen ? 'open' : ''}`}>
                <div className="navlink_description">
                    <h3>Services Informatiques</h3>
                    <p>Infrastructures complètes pour professionnels : audit de parc, maintenance, infogérance managée et déploiement de serveurs sécurisés.</p>
                    <button className="submenu_button" onClick={() => { navigate("/informatique"); setSubmenuOpen(false); }}>
                        EN SAVOIR PLUS
                    </button>
                </div>

                <div className="navlink_menu">
                    <HashLink smooth to="/ordinateur" className={isHashActive("#materiel") ? "active" : ""} onClick={() => setSubmenuOpen(false)}>Matériel & Vente</HashLink>
                    <HashLink smooth to="/infogerance" className={isHashActive("#infogerance") ? "active" : ""} onClick={() => setSubmenuOpen(false)}>Infogérance & Maintenance</HashLink>
                    <HashLink smooth to="/infrastructure" className={isHashActive("#infrastructure") ? "active" : ""} onClick={() => setSubmenuOpen(false)}>Réseaux & Infrastructure</HashLink>
                    <HashLink smooth to="/sauvegarde" className={isHashActive("#sauvegarde") ? "active" : ""} onClick={() => setSubmenuOpen(false)}>Sauvegarde Extranet</HashLink>
                </div>
            </div>
        </div>
    );
};

export default SubMenuInformatique;